export default __webpack_public_path__ + "static/media/img-video-sign-up-in-person.e1b84346.jpg";